<template>
  <v-container 
    id="normas-tecnicas-historico" 
    tag="section"
    fluid>
    <v-row align="center">
      <v-col cols="12">
        <normas-tecnicas-data-table 
          :items="items"
          :loadingItems="loadingItems"
          @rechargeTable="getAllNormasTecnicas()"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import NormasTecnicasService from "@/services/parametrosComCa/NormasTecnicasService";
import dayjs from "dayjs";

export default {
  name: "IndexCadernosServicos",

  components: {
    NormasTecnicasDataTable: () => import('@/components/parametrosComCa/normasTecnicas/NormasTecnicasDataTable.vue'),
  },

  data() {
    return {
      items: [],
      loadingItems: false,
    };
  },

  mounted() {
    this.getAllNormasTecnicas();
  },

  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  },

  methods: {
    getAllNormasTecnicas() {
      this.loadingItems = true;

      NormasTecnicasService.getAllNormasTecnicas()
        .then(response => {
          this.items = [];
          response.data.normas.forEach(element => {
            this.items.push({
              id: element.id,
              nome: element.nome,
              usuario: element.usuario.nome,
              usuario_id: element.usuario.id,
              created: element.created ? dayjs(element.created).format("DD/MM/YYYY HH:mm") : "-",   
              modified: element.modified ? dayjs(element.modified).format("DD/MM/YYYY HH:mm") : "-",   
            });
          });
        })
        .catch(err => {
          this.$toast.error("Erro ao recuperar os Cadernos de Serviços.", "", { position: "topRight"});
          console.error(err);
        })
        .finally(() => this.loadingItems = false);
    },
  }
};
</script>


<style>
  
</style>